import React, { useState, useEffect } from 'react';
import css from './WhatsAppOnTop.module.css';
// import { ReactComponent as DownArrow } from '../../assets/svg/downArrow.svg';
// import { ReactComponent as WhatsappLogo } from '../../assets/svgs/whatsapp.svg';
import { FaWhatsapp } from 'react-icons/fa';
import { useIntl } from 'react-intl';
import { getDomain } from '../../util/urlHelpers';
const WhatsAppOnTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const intl = useIntl();

  const message = intl.formatMessage(
    { id: 'ListingCard.whatsAppLinkMsg' },
    { link: getDomain(process.env.REACT_APP_MARKETPLACE_ROOT_URL) }
  );
  const whatsAppMessage = encodeURIComponent(message);

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 50) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll up when the button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  const handleWhatsAppClick = () => {
    if (typeof window !== 'undefined') {
      const countryCode = '55'; // Brazil country code
      const phoneNumber = '+96894957876';
      // const areaCode = '11'; // Area code
      // const phoneNumberwp = phoneNumber; // Phone number without hyphen
      // const formattedNumber = `${areaCode}${phoneNumberwp}`; // Combine into WhatsApp format
      // Encode the message
      const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${whatsAppMessage}`;
      // console.log(998877, formattedNumber, url);
      window.open(url, '_blank'); // Open in a new tab
    }
  };
  return (
    // isVisible && (
    //   <button onClick={handleWhatsAppClick} className={css.button} aria-label="Scroll to top">
    //     {/* <DownArrow className={css.rotatedArrow} /> */}
    //     <WhatsappLogo className={css.contacticonForwp} />
    //   </button>
    // )
    <button onClick={handleWhatsAppClick} className={css.button} aria-label="Scroll to top">
      {/* <DownArrow className={css.rotatedArrow} /> */}
      <FaWhatsapp className={css.contacticonForwp} />
    </button>
    // <button onClick={scrollToTop} className={css.button} aria-label="Scroll to top">
    //   ↑
    // </button>
  );
};

// const styles = {
//   button: {
//     position: 'fixed',
//     bottom: '20px',
//     right: '20px',
//     padding: '10px 15px',
//     fontSize: '24px',
//     backgroundColor: '#007BFF',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '50%',
//     cursor: 'pointer',
//     boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
//     transition: 'opacity 0.3s ease-in-out',
//   },
// };

export default WhatsAppOnTop;
